import type { CircleFormState } from '../studio/circle/CircleFieldInput';
import { record, rows, text } from '../studio/studio-content';

export interface Row {
  id: string;
  title: string;
  items: Array<{ index: number; caption: string }>;
}
/** Ряды вариантов: `result.data.groups` (03-api §9.4 `video_set`) или один ряд из всех файлов заказа. */
export function resultRows(state: CircleFormState): Row[] {
  const assets = state.order?.result?.assets ?? [];
  const groups = rows(record(state.order?.result?.data).groups);
  let next = 0;
  const out = groups.map(group => ({
    id: text(group.template_id) || String(next),
    title: text(group.title),
    items: rows(group.items).flatMap(item => {
      const index = Number.isInteger(item.index) ? (item.index as number) : next;
      next = index + 1;
      return assets.some(a => a.index === index) ? [{ index, caption: [text(item.caption), text(item.sub)].filter(Boolean).join(' · ') }] : [];
    }),
  }));
  const used = new Set(out.flatMap(r => r.items.map(i => i.index)));
  const rest = assets.filter(a => !used.has(a.index) && a.mime.startsWith('video/'));
  if (rest.length) out.push({ id: out.length ? 'rest' : '', title: '', items: rest.map(a => ({ index: a.index, caption: '' })) });
  return out.filter(r => r.items.length);
}

